<template>
  <el-dialog v-model="dialogFormVisible" :title="title" @close="closeDialog">
    <el-form
      :model="addRepairInfoForm"
      ref="addRepairInfoRef"
      :rules="addRepairInforules"
    >


      <el-form-item
        label="报修状态"
        :label-width="formLabelWidth"
        prop="status"
        v-model="addRepairInfoForm.status"
      >
        <el-select
          v-model="addRepairInfoForm.status"
          placeholder="请选择报修状态"
          clearable
        >
          <el-option label="新报修" :value="1"></el-option>
          <el-option label="维修中" :value="2"></el-option>
          <el-option label="已完成" :value="3"></el-option>
          <el-option label="已撤回" :value="4"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        label="报修类型"
        :label-width="formLabelWidth"
        prop="type"
      >
        <el-select
          v-model="addRepairInfoForm.type"
          placeholder="请选择报修类型"
          clearable
        >
          <el-option
            v-for="item in repairTypeList"
            :key="item.id"
            :label="item.typeName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        label="申请科室"
        :label-width="formLabelWidth"
        prop="applicantName"
      >
        <el-input
          v-model="addRepairInfoForm.applicantName"
          autocomplete="off"
          ref="name"
          placeholder="请填写申请科室"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="联系电话"
        :label-width="formLabelWidth"
        prop="mobile"
      >
        <el-input
          v-model="addRepairInfoForm.mobile"
          autocomplete="off"
          ref="name"
          placeholder="请填写科室联系电话"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="报修地点"
        :label-width="formLabelWidth"
        prop="address"
      >
        <el-input
          v-model="addRepairInfoForm.address"
          autocomplete="off"
          ref="name"
          placeholder="请填写报修地点"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="故障描述"
        :label-width="formLabelWidth"
        prop="description"
      >
        <el-input
          v-model="addRepairInfoForm.description"
          autocomplete="off"
          ref="name"
          placeholder="请填写故障描述"
        ></el-input>
      </el-form-item>

      <!-- 报修时间 -->
      <el-form-item
        label="报修时间"
        :label-width="formLabelWidth"
        prop="repairDate"
      >
        <el-date-picker
          v-model="addRepairInfoForm.repairDate"
          type="datetime"
          placeholder="请选择报修时间"
          format="YYYY-MM-DD HH:mm:ss"
          value-format="YYYY-MM-DD HH:mm:ss"
          style="width: 100%"
        ></el-date-picker>
      </el-form-item>

      <!-- 维修开始时间 -->
      <el-form-item
        v-if="addRepairInfoForm.status == 2 || addRepairInfoForm.status == 3"
        label="维修开始时间"
        :label-width="formLabelWidth"
        prop="repairStartDate"
      >
        <el-date-picker
          v-model="addRepairInfoForm.repairStartDate"
          type="datetime"
          placeholder="请选择维修开始时间"
          format="YYYY-MM-DD HH:mm:ss"
          value-format="YYYY-MM-DD HH:mm:ss"
          style="width: 100%"
        ></el-date-picker>
      </el-form-item>

      <!-- 维修完成时间 -->
      <el-form-item
        v-if="addRepairInfoForm.status == 3"
        label="维修完成时间"
        :label-width="formLabelWidth"
        prop="repairFinishDate"
      >
        <el-date-picker
          v-model="addRepairInfoForm.repairFinishDate"
          type="datetime"
          placeholder="请选择维修完成时间"
          format="YYYY-MM-DD HH:mm:ss"
          value-format="YYYY-MM-DD HH:mm:ss"
          style="width: 100%"
        ></el-date-picker>
      </el-form-item>

      <!-- 维修人员 -->
      <el-form-item
        v-if="addRepairInfoForm.status == 2 || addRepairInfoForm.status == 3"
        label="维修人员"
        :label-width="formLabelWidth"
        prop="repairman"
      >
        <el-input
          v-model="addRepairInfoForm.repairman"
          autocomplete="off"
          placeholder="请填写维修人员"
        ></el-input>
      </el-form-item>

      <!-- 维修人员电话 -->
      <el-form-item
        v-if="addRepairInfoForm.status == 2 || addRepairInfoForm.status == 3"
        label="维修人员电话"
        :label-width="formLabelWidth"
        prop="repairmanMobile"
      >
        <el-input
          v-model="addRepairInfoForm.repairmanMobile"
          autocomplete="off"
          placeholder="请填写维修人员电话"
        ></el-input>
      </el-form-item>

    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="cancel()">取消</el-button>
        <el-button type="primary" @click="save()">保存</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { ref } from "vue";
import { httpService } from "@/utils/httpService";
import { ElMessage, ElForm } from "element-plus";
import { vxRule } from "@/utils/validator";

export default {
  name: "AddRepairInfo",
  components: { ElForm, ElMessage },
  data() {
    return {
      dialogFormVisible: ref(false),
      formLabelWidth: "120px",
      title: "",
      personnelType: "",
      addRepairInfoForm: {
        status: "",
        type: "",
        repairDate: "",
        repairStartDate: "",
        repairFinishDate: "",
        repairman: "",
        repairmanMobile: "",
        address: "",
        description: "",
        imageUrl: "",
        message: "",
        evaluate: "",
        reason: "",
        consumables: "",
        applicantName: "",
        mobile: "",
        star: "",
        radioUrl: "",
        evaluateDate: "",
        openid: "",
        campus: "",
        finishTime: "",
        allocatedTime: "",
        detail: "",
        repairCancelReason: "",
        repairCancelReasonRemark: "",
        repairCancelDate: "",
        location: "",
        level: "",
      },
      // 校验规则
      addRepairInforules: {
        address: vxRule(true, null, "blur"),
        status: vxRule(true, null, "blur"),

        description: vxRule(true, null, "blur"),
        imageUrl: vxRule(true, null, "blur"),
        message: vxRule(true, null, "blur"),
        evaluate: vxRule(true, null, "blur"),
        reason: vxRule(true, null, "blur"),
        consumables: vxRule(true, null, "blur"),
        applicantName: vxRule(true, null, "blur"),
        mobile: vxRule(true, null, "blur"),
        radioUrl: vxRule(true, null, "blur"),
        openid: vxRule(true, null, "blur"),
        finishTime: vxRule(true, null, "blur"),
        detail: vxRule(true, null, "blur"),
        repairCancelReason: vxRule(true, null, "blur"),
        repairCancelReasonRemark: vxRule(true, null, "blur"),
      },
      repairTypeList: [],
    };
  },
  watch: {
    dialogFormVisible: {
      handler(val) {
        if (val) {
          this.loadRepairTypeList();
        }
      },
      immediate: false,
    },
  },
  methods: {
    loadRepairTypeList() {
      httpService("/api/sysUser/repairTypeList", {}, "get").then((data) => {
        if (data.code == 200 && data.obj) {
          this.repairTypeList = data.obj;
        }
      });
    },
    closeDialog() {
      this.clear();
    },
    cancel() {
      this.dialogFormVisible = false;
      this.clear();
    },
    getRepairInfoById(id) {
      httpService("/api/repairInfo/queryById", { id: id }, "get").then(
        (data) => {
          this.addRepairInfoForm = data;
        }
      );
    },
    clear() {
      this.dialogFormVisible = false;
      //清空form
      this.addRepairInfoForm.id = "";
      this.addRepairInfoForm.status = "";
      this.addRepairInfoForm.type = "";
      this.addRepairInfoForm.repairDate = "";
      this.addRepairInfoForm.repairStartDate = "";
      this.addRepairInfoForm.repairFinishDate = "";
      this.addRepairInfoForm.repairman = "";
      this.addRepairInfoForm.repairmanMobile = "";
      this.addRepairInfoForm.address = "";
      this.addRepairInfoForm.description = "";
      this.addRepairInfoForm.imageUrl = "";
      this.addRepairInfoForm.message = "";
      this.addRepairInfoForm.evaluate = "";
      this.addRepairInfoForm.reason = "";
      this.addRepairInfoForm.consumables = "";
      this.addRepairInfoForm.applicantName = "";
      this.addRepairInfoForm.mobile = "";
      this.addRepairInfoForm.star = "";
      this.addRepairInfoForm.radioUrl = "";
      this.addRepairInfoForm.evaluateDate = "";
      this.addRepairInfoForm.openid = "";
      this.addRepairInfoForm.campus = "";
      this.addRepairInfoForm.finishTime = "";
      this.addRepairInfoForm.allocatedTime = "";
      this.addRepairInfoForm.detail = "";
      this.addRepairInfoForm.repairCancelReason = "";
      this.addRepairInfoForm.repairCancelReasonRemark = "";
      this.addRepairInfoForm.repairCancelDate = "";
      this.addRepairInfoForm.location = "";
      this.addRepairInfoForm.level = "";
    },
    save() {
      this.$refs.addRepairInfoRef.validate((valid) => {
        if (valid) {
          let params = {
            address: this.addRepairInfoForm.address,
            description: this.addRepairInfoForm.description,
            imageUrl: this.addRepairInfoForm.imageUrl,
            message: this.addRepairInfoForm.message,
            reason: this.addRepairInfoForm.reason,
            consumables: this.addRepairInfoForm.consumables,
            applicantName: this.addRepairInfoForm.applicantName,
            mobile: this.addRepairInfoForm.mobile,
            radioUrl: this.addRepairInfoForm.radioUrl,
            detail: this.addRepairInfoForm.detail,
            status: this.addRepairInfoForm.status,
            type: this.addRepairInfoForm.type,
            repairDate: this.addRepairInfoForm.repairDate,
            repairStartDate: this.addRepairInfoForm.repairStartDate,
            repairFinishDate: this.addRepairInfoForm.repairFinishDate,
            repairman: this.addRepairInfoForm.repairman,
            repairmanMobile: this.addRepairInfoForm.repairmanMobile,
          };

          if (this.addRepairInfoForm.id) {
            params.id = this.addRepairInfoForm.id;
            httpService("/api/repairInfo/edit", params, "post").then((data) => {
              if (data.code == 200) {
                ElMessage.success("修改成功");
                this.clear();
                this.$parent.getRepairInfoList();
              } else {
                ElMessage.error("修改失败");
              }
            });
          } else {
            httpService("/api/repairInfo/add", params, "post").then((data) => {
              if (data.code == 200) {
                ElMessage.success("添加成功");
                this.clear();
                this.$parent.getRepairInfoList();
              } else {
                ElMessage.error("添加失败");
              }
            });
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style>
.el-select {
  width: 100%;
}
</style>